import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {UserService} from '../user.service';


@Injectable()
export class UserProfileResolver implements Resolve<any> {
	constructor(
		private userService: UserService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		console.log('UserProfileResolver called    #1');

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			this.userService.getUserProfile()
				.then((profile: any) => {

					console.log('UserProfileResolver called    #2');

					let profileInfo = {
						userProfile: profile,
						params: this.params
					};
					resolve(profileInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-profile.resolver.ts